module.exports = __webpack_public_path__ + "img/prize03-modal.6a69d1ec.png";